import React from "react";
import Navbar from "./Navbar";

import banner from "../assets/layout/images/project_cc_banner.jpg";
import wfm from "../assets/layout/images/project_cc_wfm.png";
import cti from "../assets/layout/images/project_cc_cti.png";
import monitor from "../assets/layout/images/project_cc_monitor.png";
import bi from "../assets/layout/images/project_cc_bi.png";

const Project_cc = () => {
  const ccItems = [
    {
      id: "wfm",
      icon: wfm,
      title: "WFM",
      desc: "WFM은 컨택센터 상담원 인력 운영을 더욱 효율적이고 안정적으로 지원할 수 있도록 개발 되었습니다. 다양한 프로젝트 수행 경험과 축적된 기술력을 바탕으로, 실제 현장의 요구를 충실히 반영해 신뢰할 수 있도록 만들어졌으며, 이미 여러 기업과 기관에서 구축·적용되어 그 안정성과 효과가 검증되었습니다.",
    },
    {
      id: "cti",
      icon: cti,
      title: "CTI 라우팅 GUI 솔루션",
      desc: "CTI 라우팅 GUI 솔루션은 컨택센터 실제 현장에서 관리자가 GUI 환경을 통해 손쉽게 라우팅을 설정하고 안정적으로 운영할 수 있도록 개발되었습니다. 아미소프트는 플랫폼의 강점을 극대화하는 동시에 파트너사의 요구를 충실히 반영하여, 신뢰성과 활용성을 모두 갖춘 전문적인 솔루션으로 완성하였습니다.​",
    },
    {
      id: "monitor",
      icon: monitor,
      title: "컨택센터 모니터링 솔루션",
      desc: "컨택센터 모니터링 솔루션은 상담 현황과 성과 지표를 실시간으로 제공하여 관리자의 운영 효율성과 상담 품질을 크게 향상시킵니다. 오랜 프로젝트 경험과 축적된 기술 노하우를 기반으로, 안정적이고 확장성 있는 모니터링 환경을 구현하였으며, 전문적인 분석 기능을 더해 컨택센터 운영 전반을 체계적으로 지원합니다​.",
    },
    {
      id: "bi",
      icon: bi,
      title: "BI 분석/보고 솔루션",
      desc: "컨택센터 모니터링 솔루션은 상담 현황과 성과 지표를 실시간으로 제공하여 관리자의 운영 효율성과 상담 품질을 크게 향상시킵니다. 오랜 프로젝트 경험과 축적된 기술 노하우를 기반으로, 안정적이고 확장성 있는 모니터링 환경을 구현하였으며, 전문적인 분석 기능을 더해 컨택센터 운영 전반을 체계적으로 지원합니다​.",
    },
  ]
  return (
    <>
      <Navbar detail />
      <section className="detail">
        <div className="container-lg" style={{ maxWidth: 1200, paddingTop: 0 }}>
          <nav className="mb-3">
            <a href="/#project" className="menu-link me-2">Business</a>
            <span className="text-muted">›</span>
            <strong className="menu-title ms-2">컨택센터</strong>
          </nav>
          {/* Title */}
          <div className="banner">
            <h1 className="detail-title">컨택센터 솔루션</h1>
            <figure className="banner-figure full-bleed">
              <img 
                className="banner-img" 
                src={banner}
                alt="컨택센터 배너이미지"
              />
            </figure>
          </div>
          <div className="detail-desc">
            아미소프트는 WFM(근무 스케줄 관리), CTI(전화·시스템 연동)을 비롯해 AI 스마트 컨택센터와 모니터링 앱까지, 다양한 컨택센터 솔루션을 자체 개발하며 
            고객 상담 환경의 혁신과 운영 효율성을 동시에 이끌어가고 있습니다. 안정적이고 유연한 시스템으로 고객사의 컨택센터가 지속적으로 발전할 수 있도록 지원합니다.
          </div>

          {/* 상세 내용 */}
          <div className="detail-items">
            {ccItems.map((i) => (
              <div className="detail-item" key={i.id}>
                <h1 className="item-title">{i.title}</h1>
                <div className="item-desc">
                  {i.desc}
                </div>
                <figure className="item-figure" >
                  <img 
                    className="item-img" 
                    src={i.icon} 
                    alt={`${i.title} 예시`}
                  />
                </figure>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Project_cc;
